// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vinfirst{
    margin: 0;
    padding: 0;
}

.vinsecond{
    font-size: 13px;
    margin: 0;
    padding: 0;
}

.vinthird{
    margin: 0;
    padding: 0;
}

.vinfourth{
    margin: 0;
}

.vinfifth{
    margin: 0;
    padding-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/TrendAnalysis_Bus/RegenerationAnalysis/RegAnalysis.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,eAAe;AACnB","sourcesContent":[".vinfirst{\n    margin: 0;\n    padding: 0;\n}\n\n.vinsecond{\n    font-size: 13px;\n    margin: 0;\n    padding: 0;\n}\n\n.vinthird{\n    margin: 0;\n    padding: 0;\n}\n\n.vinfourth{\n    margin: 0;\n}\n\n.vinfifth{\n    margin: 0;\n    padding-left: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
